import type { Release } from '../releases.ts';

export default {
  version: '0.18.6',
  date: '2026-10-03',
  title: 'Moving an original from a site to central storage',
  summary: [
    'Fixed: moving an original from a site to central storage completes and removes the site copy',
  ],
  features: [],
  fixes: [
    'Moving an original from a site to central storage now completes and removes the site copy through its storage agent',
  ],
} satisfies Release;
